import connectionProxy from "./connectionProxy";

export const getLicenses = (term = '', third_parties = false) => connectionProxy.http.get(`/licencas?term=${term}&third_parties=${third_parties}`);
export const getLicense = id => connectionProxy.http.get(`/licencas/${id}`);
export const getLicensesForArea = (areaId, term = '', third_parties = false) => connectionProxy.http.get(`licencas/licencas_por_area?area_id=${areaId}&term=${term}&third_parties=${third_parties}`);
export const getRelationAreas = () => {
  return connectionProxy.http.get(`licencas/areas`);
}



// WEBPACK FOOTER //
// ./src/api/license.js